import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconArrowDown = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 16} height={props.height || 16} viewBox="0 0 16 16" fill="none">
      <path
        d="M4 6L8 10L12 6"
        stroke={theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}
